import os from '@edu-fe/os'

/**
 * 客户端内登录
 * @param {Function} callback 登录成功回调
 * @param {Promise} 登录结果
 */
export default function login (callback) {
  return os.sdk.user.login()
    .then(wpsSid => {
      callback && callback(wpsSid)
      return wpsSid
    })
}
